export default __webpack_public_path__ + "static/media/HelveticaNeue Thin.c4606aee.ttf";